import getLangKey from './getLangKey';
export const TRAINING_AND_SERVICES_LINKS = {
  en: 'https://www.hubspot.com/services',
  ja: 'https://www.hubspot.jp/services',
  de: 'https://www.hubspot.de/services',
  es: 'https://www.hubspot.es/services',
  pt: 'https://br.hubspot.com/services',
  fr: 'https://www.hubspot.fr/services'
};
const getTrainingAndServicesLink = () => TRAINING_AND_SERVICES_LINKS[getLangKey()] || TRAINING_AND_SERVICES_LINKS.en;
export default getTrainingAndServicesLink;